/**
 * 医生挂号设置模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 获取挂号设置列表
export const registerList = (params) => {
  return req.get('/scheduling/info/list', params);
}

// 获取挂号设置详情
export const registerInfo = (doctorId, deptId) => {
  return req.get(`/scheduling/info/doctor/${doctorId}/${deptId}`);
}

// 新增挂号设置
export const registerAdd = (params) => {
  return req.post('/scheduling/info', params);
}

// 修改挂号设置信息
export const registerEdit = (params) => {
  return req.put('/scheduling/info', params);
}

// 根据医生Id、医馆Id、挂号类型获取挂号费
export const registerPrice = (params) => {
  return req.get('/scheduling/item/getInfoByType', params);
}
// 补录挂号
export const replenish = (params) => {
  return req.post('/order/registered/replenish', params);
}

//查询医生排班 列表
export const doctorSchedulingList = (params) => {
  return req.get('/scheduling/item/getSchedulingList', params)
}

//查询医生班次
export const getSchedulingTime = (params) => {
  return req.get('/scheduling/item/getSchedulingTime', params)
}

//查询挂号列表
export const getRegisterList = (params) => {
  return req.get('/order/registered/getRegisterList', params)
}

//查询挂号单数量
export const getRegisterStatusNum= (params) => {
  return req.get('/order/registered/getRegisterStatusNum', params)
}

//签到
export const registerSignIn = (params) => {
  return req.post('/order/signIn/registerSignIn', params)
}

//获取挂号详情
export const getInfo = (params) => {
  return req.get('/order/registered/getInfo', params)
}

//查询初诊复诊
export const getDoctorVisit = (params) => {
  return req.get('/order/info/getDoctorVisit', params)
}





